import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect(
  "/leads/all_center_of_production_zips",
  {
    displayName: "ProductionOfficeZipSelect",
    defaultPlaceholder: "Select Zip",
  },
);
